import { media } from "@/helpers/media";
import useForm from "@/Hooks/useForm";
import { router, usePage } from "@inertiajs/react";

function AuthDefault({ property, error }) {
    const { url } = usePage();

    const { values, register, handleSubmit } = useForm({
        initialValues: {
            password: "",
        },
    });

    function onSubmit(values) {
        router.visit(url, {
            method: "post",
            data: values,
        });
    }

    return (
        <div className="relative min-h-screen">
            <img
                className={
                    "absolute top-0 left-0 size-full object-cover object-center" +
                    (property.gray_scale ? " filter grayscale" : "")
                }
                src={media(property.featured_image, "large")}
                alt={property.featured_image ? property.featured_image.alt : property.title}
                translate="no" lang="en"
            />
            <div className="relative min-h-screen flex flex-col items-center justify-center bg-black/50 text-white">
                <div className="max-w-md mx-auto w-content">
                    <h1 className="uppercase text-6xl text-center" translate="no" lang="en">
                        {property.title}
                    </h1>
                    <form className="mt-8 text-[1.3rem]" onSubmit={handleSubmit(onSubmit)}>
                        {error && (
                            <div className="text-red px-4 py-2 bg-red-700 rounded-sm text-white mb-4">
                                {error}
                            </div>
                        )}
                        <input
                            className="border-none  w-full px-4 py-2 font-serif rounded-sm text-light placeholder:text-light text-center focus:ring-2 focus:ring-light"
                            {...register({
                                id: "password",
                                name: "password",
                                type: "password",
                                required: true,
                                placeholder: "Enter Password",
                            })}
                        />
                        <button
                            type="submit"
                            className="w-full px-4 py-2 mt-4 bg-light rounded-sm font-serif"
                        >
                            Access
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AuthDefault;
